import { injectable } from 'inversify';
import React from 'react';

import { User } from '@project44/ui-utils';

import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import { LogoutCard, TLogoutCard } from './LogoutCard.view';

@injectable()
export class LogoutCardComponent extends ReactComponent {
  public static create(props: { user: User }): React.ReactElement<TLogoutCard> {
    return LogoutCard(props);
  }
}
